import { useParams, useNavigate } from 'react-router';

import { CompanyRelationshipMutations } from './relationship_mutations_container';
import { RelationshipView } from '../components/relationship';

export const RelationshipContainer = () => {
  const { company_relationship_id, company_id } = useParams() as {
    company_id: string;
    company_relationship_id: string;
  };
  const navigate = useNavigate();
  const isNewRelationship = company_relationship_id === 'new';

  return (
    <CompanyRelationshipMutations>
      {({ createCompanyRelationship }) => (
        <RelationshipView
          createCompanyRelationship={createCompanyRelationship}
          isNewRelationship={isNewRelationship}
          routeProps={{
            goBack: () => navigate(-1),
            company_id,
          }}
        />
      )}
    </CompanyRelationshipMutations>
  );
};
